import styled from 'styled-components';
import { RowTable } from '../../../../func/components/Table';
import { ReportFormatNumber } from '../../../../func/Function';
import { useState } from 'react';

const Category = ['구분', '매각기일', '최저매각가격', '결과'];

const transformData = (item: {
  no: string;
  date: string;
  minprice: string;
  result: string;
}) => {
  return [
    { key: Category[0], value: item.no },
    { key: Category[1], value: item.date },
    {
      key: Category[2],
      value: item.minprice.includes('매각')
        ? item.minprice.split('-')[0] +
          '-' +
          (ReportFormatNumber(item.minprice.split('-')[1]) || null)
        : ReportFormatNumber(item.minprice) || null,
    },
    { key: Category[3], value: item.result ? item.result : '-' },
  ];
};

const SaleInfo = ({ data }: any) => {
  const [showAll, setShowAll] = useState(false);

  return (
    <Container id="매각정보">
      <div>매각정보</div>
      <ContentWrapper>
        {data
          .slice(0, showAll ? data.length : 2)
          .map((item: any, index: number) => {
            return (
              <RowTable
                data={transformData(item)}
                key={index}
                titleWidth={120}
              />
            );
          })}

        {data.length > 2 && (
          <MoreButton
            onClick={() => {
              setShowAll((prev) => !prev);
            }}
          >
            <div>{showAll ? '닫기' : '더보기'}</div>
            <img
              style={{
                transform: showAll ? 'rotate(180deg)' : 'rotate(0deg)',
              }}
              src="/assets/images/arrow/Arrow_down.png"
            ></img>
          </MoreButton>
        )}
      </ContentWrapper>
    </Container>
  );
};

export default SaleInfo;

const MoreButton = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  gap: 4px;
  color: black;
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 400;
  line-height: 18.85px;
  word-wrap: break-word;
  border-radius: 4px;
  border: 1px #e1e2e4 solid;

  img {
    width: 16px;
    height: 16px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 16px;
  background-color: #fff;
  gap: 24px;

  color: #222222;
  font-size: 18px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 26.1px;
  word-wrap: break-word;
`;
